import { DeviceOption } from '../lib/media'
import { Icon } from './Icon'

interface Props {
  cameras: DeviceOption[]
  mics: DeviceOption[]
  cameraId: string
  micId: string
  mirror: boolean
  systemAudio: boolean
  camOff: boolean
  micOff: boolean
  busy: boolean
  onChange(patch: Partial<{
    cameraId: string; micId: string; mirror: boolean
    systemAudio: boolean; camOff: boolean; micOff: boolean
  }>): void
  onStart(): void
}

export function SetupPanel(p: Props) {
  return (
    <div className="card">
      <h2>Before you hit record</h2>
      <p className="sub">
        Bloom captures your screen and your face at the same time and merges them into one video.
        Pick your devices, then choose what to share.
      </p>

      <div className="grid2">
        <div className="field">
          <label htmlFor="cam">Camera</label>
          <select
            id="cam"
            value={p.cameraId}
            disabled={p.camOff}
            onChange={(e) => p.onChange({ cameraId: e.target.value })}
          >
            {p.cameras.length === 0 && <option value="">No camera found</option>}
            {p.cameras.map((c) => (
              <option key={c.deviceId} value={c.deviceId}>{c.label}</option>
            ))}
          </select>
          <label className="toggle small">
            <input
              type="checkbox"
              checked={p.camOff}
              onChange={(e) => p.onChange({ camOff: e.target.checked })}
            />
            Record screen only (no face)
          </label>
        </div>

        <div className="field">
          <label htmlFor="mic">Microphone</label>
          <select
            id="mic"
            value={p.micId}
            disabled={p.micOff}
            onChange={(e) => p.onChange({ micId: e.target.value })}
          >
            {p.mics.length === 0 && <option value="">No microphone found</option>}
            {p.mics.map((m) => (
              <option key={m.deviceId} value={m.deviceId}>{m.label}</option>
            ))}
          </select>
          <label className="toggle small">
            <input
              type="checkbox"
              checked={p.micOff}
              onChange={(e) => p.onChange({ micOff: e.target.checked })}
            />
            Record without my voice
          </label>
        </div>
      </div>

      <div style={{ height: 18 }} />

      <div className="wrap-row">
        <label className="toggle">
          <input
            type="checkbox"
            checked={p.mirror}
            onChange={(e) => p.onChange({ mirror: e.target.checked })}
          />
          Mirror my camera
        </label>
        <label className="toggle">
          <input
            type="checkbox"
            checked={p.systemAudio}
            onChange={(e) => p.onChange({ systemAudio: e.target.checked })}
          />
          Also capture computer audio
        </label>
      </div>

      <div style={{ height: 20 }} />

      <button className="btn primary big" onClick={p.onStart} disabled={p.busy}>
        <Icon name="monitor" size={17} />
        {p.busy ? 'Starting…' : 'Choose a screen and start'}
      </button>
    </div>
  )
}
